import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import CropFailedOrdersContext from './CropFailedOrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

const CropFailedOrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <CropFailedOrdersContext.Provider value={{ actions, state }}>
      {children}
    </CropFailedOrdersContext.Provider>
  );
};

export default CropFailedOrdersProvider;
